module.exports = __webpack_public_path__ + "img/shot-1.3ab6d51a.png";